import {PersonalAccount} from './personal-account';

const initPersonalAccount = () => {
  const personalAccount = new PersonalAccount();
  personalAccount.init();
};

export {initPersonalAccount};
